import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

import errorToast from "helpers/errorToast";
import { updateExchangeRate } from "api";
import Dialog from "components/organisms/Dialog/Dialog";
import Button from "components/atoms/Button/Button";

interface CurrencyExchangeRateDialogProps {
  currency: string | null;
  targetCurrency: string;
  show: boolean;
  close: () => void;
  setExchangeRateCurrency: (currency: null) => void;
  invoiceId: string | null;
  refetch: (currency: string | null, revert: boolean) => void;
}

function CurrencyExchangeRateDialog({
  currency,
  targetCurrency,
  setExchangeRateCurrency,
  close,
  show,
  invoiceId,
  refetch,
}: CurrencyExchangeRateDialogProps) {
  const intl = useIntl();
  const [isUpdating, setIsUpdating] = useState(false);
  const [exchangeFactor, setExchangeFactor] = useState("");

  const onSubmit = () => {
    if (!exchangeFactor) return;
    setIsUpdating(true);

    updateExchangeRate(invoiceId, {
      currency,
      target_currency: targetCurrency,
      factor: exchangeFactor,
    })
      .then(() => {
        refetch(currency, false);
        handleCloseDialog();
      })
      .catch((error) => errorToast(error))
      .finally(() => setIsUpdating(false));
  };

  const handleCloseDialog = () => {
    setExchangeFactor("");
    setExchangeRateCurrency(null);
    close();
  };
  return (
    <Dialog
      size="md"
      show={show}
      onHide={handleCloseDialog}
      title={intl.formatMessage({
        id: "general.exchangeRate",
        defaultMessage: "Exchange rate",
      })}
    >
      <form>
        <div className="text-secondary d-flex flex-column">
          <div>
            <FormattedMessage
              id="invoice.updateExchangeRate"
              defaultMessage="You can only update the exchange rate before you submit the final cost."
            />
          </div>
          <div>
            <FormattedMessage id="invoice.notifyShipper" defaultMessage="The shipper will be notified." />
          </div>
        </div>
        <Row className="d-flex align-items-center">
          <Col md={3} className="font-weight-bold mt-5 mb-5">
            1 {currency} = {targetCurrency}
          </Col>
          <Col md={9}>
            <input
              placeholder="Enter rate factor"
              className="rounded-input input-width-lg"
              onChange={(e) => setExchangeFactor(e.target.value)}
            />
          </Col>
        </Row>
        <div className="d-flex justify-content-between">
          <Button variant="outline-primary" onClick={handleCloseDialog}>
            <FormattedMessage id="general.cancel" defaultMessage="Cancel" />
          </Button>
          <Button isLoading={isUpdating} onClick={onSubmit} disabled={!exchangeFactor}>
            <FormattedMessage id="general.submit" defaultMessage="Submit" />
          </Button>
        </div>
      </form>
    </Dialog>
  );
}

export default CurrencyExchangeRateDialog;
